export { default } from './HBActionArea';
export { useActionArea } from './useActionArea';
export type { HBActionAreaProps } from './HBActionArea.types';
